( function( $ ) {

	$(document).ready( function() {

		$( '.underdev-settings .pretty-select' ).selectize();

	} );

} )( jQuery );
